"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Versioning_1 = require("../versioning/Versioning");

var DefaultSigV4 = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  function DefaultSigV4(chimeClient, awsClient) {
    _classCallCheck(this, DefaultSigV4);

    this.chimeClient = chimeClient;
    this.awsClient = awsClient;
  }

  _createClass(DefaultSigV4, [{
    key: "makeTwoDigits",
    value: function makeTwoDigits(n) {
      /* istanbul ignore if */

      /* istanbul ignore else */
      if (n > 9) {
        return n.toString();
      } else {
        return '0' + n.toString();
      }
    }
  }, {
    key: "getDateTimeString",
    value: function getDateTimeString() {
      var d = new Date();
      return d.getUTCFullYear() + this.makeTwoDigits(d.getUTCMonth() + 1) + this.makeTwoDigits(d.getUTCDate()) + 'T' + this.makeTwoDigits(d.getUTCHours()) + this.makeTwoDigits(d.getUTCMinutes()) + this.makeTwoDigits(d.getUTCSeconds()) + 'Z';
    }
  }, {
    key: "getDateString",
    value: function getDateString(dateTimeString) {
      return dateTimeString.substring(0, dateTimeString.indexOf('T'));
    }
  }, {
    key: "getSignatureKey",
    value: function getSignatureKey(key, date, regionName, serviceName) {
      var kDate = this.awsClient.util.crypto.hmac('AWS4' + key, date, 'buffer');
      var kRegion = this.awsClient.util.crypto.hmac(kDate, regionName, 'buffer');
      var kService = this.awsClient.util.crypto.hmac(kRegion, serviceName, 'buffer');
      var kSigning = this.awsClient.util.crypto.hmac(kService, 'aws4_request', 'buffer');
      return kSigning;
    }
  }, {
    key: "signURL",
    value: function signURL(method, scheme, serviceName, hostname, path, payload, queryParams) {
      var now = this.getDateTimeString();
      var today = this.getDateString(now);
      var algorithm = 'AWS4-HMAC-SHA256';
      var region = this.chimeClient.config.region;
      var signedHeaders = 'host';
      var canonicalHeaders = 'host:' + hostname.toLowerCase() + '\n';
      var credentialScope = today + '/' + region + '/' + serviceName + '/' + 'aws4_request';
      var credentials = this.chimeClient.config.credentials;
      var params = new Map();
      params.set('X-Amz-Algorithm', [algorithm]);
      params.set('X-Amz-Credential', [encodeURIComponent(credentials.accessKeyId + '/' + credentialScope)]);
      params.set('X-Amz-Date', [now]);
      params.set('X-Amz-Expires', ['10']);
      params.set('X-Amz-SignedHeaders', ['host']);

      if (credentials.sessionToken) {
        params.set('X-Amz-Security-Token', [encodeURIComponent(credentials.sessionToken)]);
      }

      params.set(Versioning_1.default.X_AMZN_VERSION, [encodeURIComponent(Versioning_1.default.sdkVersion)]);
      params.set(Versioning_1.default.X_AMZN_USER_AGENT, [encodeURIComponent(Versioning_1.default.sdkUserAgentLowResolution)]);
      queryParams === null || queryParams === void 0 ? void 0 : queryParams.forEach(function (values, key) {
        var encodedKey = encodeURIComponent(key);
        values.sort().forEach(function (value) {
          if (!params.has(encodedKey)) {
            params.set(encodedKey, []);
          }

          params.get(encodedKey).push(encodeURIComponent(value));
        });
      });
      var canonicalQuerystring = '';
      params = new Map(_toConsumableArray(params.entries()).sort());
      params.forEach(function (values, key) {
        values.forEach(function (value) {
          if (canonicalQuerystring.length) {
            canonicalQuerystring += '&';
          }

          canonicalQuerystring += key + '=' + value;
        });
      });
      var canonicalRequest = method + '\n' + path + '\n' + canonicalQuerystring + '\n' + canonicalHeaders + '\n' + signedHeaders + '\n' + this.awsClient.util.crypto.sha256(payload, 'hex');
      var hashedCanonicalRequest = this.awsClient.util.crypto.sha256(canonicalRequest, 'hex');
      var stringToSign = 'AWS4-HMAC-SHA256\n' + now + '\n' + today + '/' + region + '/' + serviceName + '/aws4_request\n' + hashedCanonicalRequest;
      var signingKey = this.getSignatureKey(credentials.secretAccessKey, today, region, serviceName);
      var signature = this.awsClient.util.crypto.hmac(signingKey, stringToSign, 'hex');
      var finalParams = canonicalQuerystring + '&X-Amz-Signature=' + signature;
      return scheme + '://' + hostname + path + '?' + finalParams;
    }
  }]);

  return DefaultSigV4;
}();

exports.default = DefaultSigV4;